import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { waUrl, WA_GENERAL } from "../config/site";
import WhatsAppIcon from "./WhatsAppIcon";
import { Reveal } from "./Reveal";

export default function CTABlock({
  title = "Tell us what you need. We’ll help you build it.",
  sub = "Send your uniform requirement and our team will review the product, quantity, customization and delivery details.",
}) {
  return (
    <section className="bg-obsidian text-white" data-testid="cta-block">
      <div className="container-site py-20 lg:py-28">
        <Reveal>
          <p className="eyebrow !text-white/50">Start your requirement</p>
          <h2 className="mt-4 max-w-3xl font-display text-3xl font-extrabold leading-[1.08] tracking-tight sm:text-4xl lg:text-5xl">
            {title}
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-white/60">{sub}</p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <Link to="/bulk-quote" data-event="bulk_quote_click" data-testid="cta-block-quote-btn" className="btn-primary">
              Get Bulk Quote <ArrowRight className="h-4 w-4" />
            </Link>
            <a
              href={waUrl(WA_GENERAL)}
              target="_blank"
              rel="noopener noreferrer"
              data-event="whatsapp_click"
              data-testid="cta-block-whatsapp-btn"
              className="btn-outline-light"
            >
              <WhatsAppIcon className="h-4 w-4 text-[#25D366]" /> WhatsApp Us
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
